// extracted by mini-css-extract-plugin
export default {"menu":"MenuButton_menu__APA7Q","caret":"MenuButton_caret__dlg8n","icon":"MenuButton_icon__lDHMV","ripple":"MenuButton_ripple__WH6yF"};